<template>
  <div>
    <div class="row cards">
      <div class="col-md-3 card" v-for="(exploracao, index) in exploracoes" :key="index">
        <span
          style="max-width: 158px;"
        >{{ exploracao.explorationType === 'ANIMAL' ? exploracao.nomeTipoExploracao : exploracao.nome_cultura }}</span>
        <div class="actions">
          <i class="fa fa-edit" title="Editar" @click="onEditExploracaoClick(index)"></i>
          <i class="fa fa-trash" title="Apagar" @click="onRemoveExploracaoClick(index)" v-if="!exploracao.cod_exploracao_sidagro"></i>
        </div>
      </div>
    </div>
    <div class="btn-primary" @click="onAddExploracaoClick">
      <span>Adicionar Exploração</span>
    </div>

    <modal-component
      title="Adicionar exploração"
      :value="showModal"
      @input="onCloseModal"
      v-if="activeIndex !== null"
    >
      <div class="modal-content">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group required">
              <label>Tipo de exploração</label>
              <select class="form-control" v-model="exploracoes[activeIndex].explorationType">
                <option value>Selecione</option>
                <option value="ANIMAL">Animal</option>
                <option value="VEGETAL">Vegetal</option>
              </select>
            </div>
          </div>
        </div>

        <template v-if="exploracoes[activeIndex].explorationType === 'ANIMAL'">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group required">
                <label>Tipo de Produtor</label>
                <select class="form-control" v-model="exploracoes[activeIndex].cod_tipo_produtor"
                        @change="onChangeTipoProdutor()"
                >
                  <option value>Selecione</option>
                  <option
                    v-for="(item, index) in tiposProdutor"
                    :key="index"
                    :value="item.cod"
                  >{{ item.nome }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <template v-if="ehArrendatario == true || exploracoes[activeIndex].cod_tipo_produtor == 2">

            <div class="row">

              <div class="col-md-6">
                <div class="form-group required">
                  <label>CPF/CNPJ proprietário</label>
                  <input class="form-control" type="tel"
                         v-mask="['###.###.###-##', '##.###.###/####-##']"
                         v-model="exploracoes[activeIndex].cpf_proprietario_arrendamento"
                  >
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group required">
                  <label>Código Propriedade</label>
                  <input class="form-control" type="text" v-model="exploracoes[activeIndex].cod_propriedade_arrendamento" >
                </div>
              </div>

            </div>

          </template>

        </template>

        <template v-if="exploracoes[activeIndex].explorationType === 'VEGETAL'">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group required">
                <label>Cultura</label>
                <select
                  v-model="exploracoes[activeIndex].cultura_id"
                  class="form-control"
                  @change="onChangeCultura"
                  :disabled="loadingVariedades"
                >
                  <option value>Selecione</option>
                  <option
                    v-for="(item, index) in culturas"
                    :key="index"
                    :value="item.id"
                  >{{ item.nome }}</option>
                </select>
              </div>
            </div>
            <template
              v-if="exploracoes[activeIndex] && exploracoes[activeIndex].variedades.length > 0"
            >
              <div class="col-md-6">
                <div class="form-group required">
                  <label>Variedade</label>
                  <select
                    v-model="exploracoes[activeIndex].variedade_id"
                    class="form-control"
                    @change="onVariedadeChange"
                  >
                    <option value>Selecione</option>
                    <option
                      v-for="(variedade, index) in exploracoes[activeIndex].variedades"
                      :key="index"
                      :value="variedade.id"
                    >{{ variedade.nome }}</option>
                  </select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group required">
                  <label>Área total (hectares)</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model.lazy="exploracoes[activeIndex].area_up"
                    v-money="hectareMask"
                  />
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group required">
                  <label>Data Plantio</label>
                  <input
                    type="date"
                    class="form-control"
                    v-model.lazy="exploracoes[activeIndex].dt_plantio"
                  />
                </div>
              </div>

              <div class="col-md-6" v-if="[480, 384].includes(exploracoes[activeIndex].cultura_id)" >
                <div class="form-group required">
                  <label>Origem da semente</label>
                  <input
                    type="input"
                    class="form-control"
                    v-model.lazy="exploracoes[activeIndex].origem_semente"
                  />
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group required">
                  <label>Necessita RT</label>
                  <select v-model="exploracoes[activeIndex].necessita_rt" class="form-control">
                    <option value>Selecione</option>
                    <option value="sim">Sim</option>
                    <option value="nao">Não</option>
                  </select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group required">
                  <label>Quantidade Estimada</label>
                  <input
                    type="number"
                    class="form-control"
                    v-model="exploracoes[activeIndex].quantidade"
                  />
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group required">
                  <label>Unidade de Medida</label>
                  <select v-model="exploracoes[activeIndex].unidade" class="form-control"
                    @change="onChangeUnidade"
                  >
                    <option value>Selecione</option>
                    <option
                      v-for="(item, index) in unidadesMedidaVegetal"
                      :key="index"
                      :value="item.cod"
                    >{{ item.nome }}</option>
                  </select>
                </div>
              </div>

              <div class="col-md-6" v-if="exploracoes[activeIndex].necessita_rt === 'sim'">
                <div class="form-group required">
                  <label>Nome RT</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="exploracoes[activeIndex].rt_name"
                  />
                </div>
              </div>
              <div class="col-md-6" v-if="exploracoes[activeIndex].necessita_rt === 'sim'">
                <div class="form-group required">
                  <label>CPF RT</label>
                  <input
                    type="tel"
                    class="form-control"
                    v-model="exploracoes[activeIndex].rt_cpf"
                    v-mask="['###.###.###-##']"
                    @blur="onCpfBlur(exploracoes[activeIndex])"
                  />
                </div>
              </div>
            </template>
          </div>
        </template>
        <template v-if="exploracoes[activeIndex].explorationType === 'ANIMAL'">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group required">
                <label>Tipo da exploração</label>
                <select
                  v-model="exploracoes[activeIndex].tipoExploracao"
                  class="form-control"
                  @change="onChangeTipoExploracao"
                  :disabled="loadingFaixasEtarias"
                >
                  <option value>Selecione</option>
                  <option
                    v-for="(item, index) in validExplorationTypes"
                    :key="index"
                    :value="item.cod"
                  >{{ item.nome }}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group required">
                <label>Área total (hectares)</label>
                <input
                  type="text"
                  class="form-control"
                  v-model.lazy="exploracoes[activeIndex].area_up"
                  v-money="hectareMask"
                />
              </div>
            </div>
          </div>
          <div
            class="row"
            v-for="(faixaEtaria, index) in exploracoes[activeIndex].faixasEtarias"
            :key="index"
          >
            <div class="col-md-3">
              <div class="description">
                <h4>{{ faixaEtaria.faixa_etaria }}</h4>
                <h5>Sexo: {{ faixaEtaria.sexo === 'I' ? 'Indefinido' : faixaEtaria.sexo }}</h5>
              </div>
            </div>
            <div class="col-md-9">
              <div class="form-group required">
                <label>Quantidade Estimada</label>
                <input type="number" class="form-control" v-model="faixaEtaria.quantidade" />
              </div>
            </div>
          </div>
        </template>
      </div>
      <div class="modal-footer">
        <div class="btn-primary" @click="onSaveClick" :disabled="loadingFaixasEtarias">
          <span>Salvar</span>
        </div>
      </div>
    </modal-component>
  </div>
</template>

<script>
export default {
  props: ["explorationList"],
  data: () => ({
    exploracoes: [],
    showModal: false,
    tiposExploracao: [],
    culturas: [],
    loadingFaixasEtarias: false,
    loadingVariedades: false,
    activeIndex: null,
    requestListSource: null,
    hectareMask: {
      decimal: ",",
      thousands: ".",
      prefix: "",
      suffix: " ha",
      precision: 2
    },
    unidadesMedidaVegetal: [],
    tiposProdutor: [],
    ehArrendatario: false
  }),
  computed: {
    validExplorationTypes() {
      return this.tiposExploracao.filter(type => {
        return !this.exploracoes.some(
          (exploracao, index) =>
            exploracao.tipoExploracao === type.cod && index !== this.activeIndex
        );
      });
    },
    validCulturas() {}
  },
  watch: {
    explorationList: function(val) {
      this.exploracoes = val;
    },
    activeIndex: function(val) {
      if (val !== null && this.exploracoes[val].explorationType === "VEGETAL" && this.exploracoes[val].variedades.length == 0) {
        this.onChangeCultura();
      } else if (val !== null && this.exploracoes[val].explorationType === "ANIMAL" && this.exploracoes[val].faixasEtarias.length == 0) {
        if (!this.exploracoes[val].tipoExploracao) {
          this.exploracoes[val].tipoExploracao = this.tiposExploracao.find(
            item => item.nome == this.exploracoes[this.activeIndex].nomeTipoExploracao
          ).cod;
        }

        this.onChangeTipoExploracao();
      }
    }
  },
  methods: {
    onChangeTipoExploracao() {
      this.loadingFaixasEtarias = true;
      this.exploracoes[
        this.activeIndex
      ].nomeTipoExploracao = this.tiposExploracao.find(
        item => item.cod == this.exploracoes[this.activeIndex].tipoExploracao
      ).nome;

      const tipoExploracao = this.exploracoes[this.activeIndex].tipoExploracao;
      const CancelToken = axios.CancelToken;
      this.requestListSource = CancelToken.source();

      axios
        .get(
          `/produtor/pre-cadastro/get-faixas-etarias-exploracao?cod_especie=${tipoExploracao}`,
          {
            cancelToken: this.requestListSource.token
          }
        )
        .then(response => response.data)
        .then(response => {
          const { data } = response;
          const items = data.map(item => {
            item.quantidade = 0;
            return item;
          });
          this.exploracoes[this.activeIndex].faixasEtarias = items;
        })
        .catch(error => {
          console.log("error", error);
        })
        .then(() => {
          this.loadingFaixasEtarias = false;
        });
    },
    onCloseModal(ev) {
      this.requestListSource &&
        this.requestListSource.cancel("Operation canceled automatically.");
      if (!this.exploracoes[this.activeIndex].saved) {
        this.exploracoes.splice(this.activeIndex, 1);
      }

      this.showModal = false;
      this.activeIndex = null;
      this.ehArrendatario = false;
      document.querySelector("body").classList.remove("modal-show");
    },
    onSaveClick() {
      let hasError = false;
      this.$el
        .querySelectorAll(".sida-modal.show .form-group.required")
        .forEach(node => {
          const formControl = node.querySelector(".form-control");
          if (!formControl.value) {
            node.classList.add("error");
            hasError = true;
          } else {
            node.classList.remove("error");
          }
        });

      if (this.exploracoes[this.activeIndex].cpf_proprietario_arrendamento
        && this.exploracoes[this.activeIndex].cod_propriedade_arrendamento) {

        axios
          .get(
            `/produtor/pre-cadastro/verifica-arrendamento`,
            {
              params: {
                cpf_cnpj: this.exploracoes[this.activeIndex].cpf_proprietario_arrendamento,
                cod_propriedade : this.exploracoes[this.activeIndex].cod_propriedade_arrendamento,
              }
            }
          )
          .then(response => response.data)
          .then(response => {
            const { data } = response;

            if (!data.confere_arrendamento && false) {
              alert("O CPF/CNPJ informado não está associada ao código da propriedade informada.");
            } else {
              this.exploracoes[this.activeIndex].saved = true;
              this.onCloseModal(true);
              this.$emit("save", this.exploracoes);
            }
          })
          .catch(error => {
            alert("Erro ao validar dados de arrendamento");
          })
      } else {
        if (!hasError) {
          this.exploracoes[this.activeIndex].saved = true;
          this.onCloseModal(true);
          this.$emit("save", this.exploracoes);
        }
      }
    },
    onRemoveExploracaoClick(index) {
      this.exploracoes.splice(index, 1);
      this.ehArrendatario = false;
    },
    onEditExploracaoClick(index) {
      this.activeIndex = index;
      this.showModal = true;
      this.ehArrendatario = false;
    },
    onAddExploracaoClick() {
      const emptyExploracao = {
        saved: false,
        explorationType: "",
        // Vegetal
        variedade_id: "",
        nome_variedade: "",
        cultura_id: "",
        nome_cultura: "",
        necessita_rt: "",
        rt_name: "",
        rt_cpf: "",
        area_up: "",
        quantidade: "",
        variedades: [],
        // Animal
        tipoExploracao: "",
        nomeTipoExploracao: "",
        unidade: "",
        nome_unidade: "",
        cod_tipo_produtor: "",
        nome_tipo_produtor: "",
        cpf_proprietario_arrendamento: "",
        cod_propriedade_arrendamento: "",
        faixasEtarias: []
      };
      this.exploracoes.push(emptyExploracao);
      this.activeIndex = this.exploracoes.length - 1;
      this.showModal = true;
      this.ehArrendatario = false;
    },
    getTiposExploracao(count = 0) {
      if (count > 3) {
        alert("Erro ao buscar explorações. Tente novamente mais tarde.");
      }

      axios
        .get("/produtor/pre-cadastro/get-tipos-exploracao")
        .then(response => response.data)
        .then(response => {
          const { data } = response;
          this.tiposExploracao = data;
        })
        .catch(error => {
          console.log("error", error);
          this.getTiposExploracao(count++);
        });
    },
    getCulturas() {
      axios
        .get("/produtor/pre-cadastro/get-culturas")
        .then(response => response.data)
        .then(response => {
          const { data } = response;
          this.culturas = data;
        })
        .catch(error => {
          console.log("error", error);
          alert("Erro ao tentar recuperar as culturas.");
        });
    },
    onChangeCultura() {
      if (!this.exploracoes[this.activeIndex].cultura_id) return;

      // Marcos => Limpar campo origem semente, deve existir uma forma melhor
      // vou verificar no futuro
      if (![480, 384].includes(this.exploracoes[this.activeIndex].cultura_id)) {
        this.exploracoes[this.activeIndex].origem_semente = "";
      }

      this.loadingVariedades = true;
      this.exploracoes[this.activeIndex].nome_cultura = this.culturas.find(
        item => item.id === this.exploracoes[this.activeIndex].cultura_id
      ).nome;

      const clutura_id = this.exploracoes[this.activeIndex].cultura_id;
      const CancelToken = axios.CancelToken;
      this.requestListSource = CancelToken.source();

      axios
        .get(
          `/produtor/pre-cadastro/get-variedades-from-cultura?id=${clutura_id}`,
          {
            cancelToken: this.requestListSource.token
          }
        )
        .then(response => response.data)
        .then(response => {
          const { data } = response;
          this.exploracoes[this.activeIndex].variedades = data;
        })
        .catch(error => {
          console.log("error", error);
        })
        .then(() => {
          this.loadingVariedades = false;
        });
    },
    onVariedadeChange() {
      if (this.exploracoes[this.activeIndex].variedade_id) {
        this.exploracoes[this.activeIndex].nome_variedade = this.exploracoes[
          this.activeIndex
        ].variedades.find(
          item => item.id == this.exploracoes[this.activeIndex].variedade_id
        ).nome;
      } else {
        this.exploracoes[this.activeIndex].nome_variedade = "";
      }
    },
    onCpfBlur(exploration) {
      if (
        exploration.rt_cpf !== "" &&
        !window.cpfValidation(exploration.rt_cpf)
      ) {
        exploration.rt_cpf = "";
        alert("CPF do RT inváliddo");
      }
    },

    onCpfBlurArrendatario(exploration) {
      if (
        exploration.cpf_proprietario_arrendamento !== "" &&
        !window.cpfValidation(exploration.cpf_proprietario_arrendamento)
      ) {
        exploration.cpf_proprietario_arrendamento = "";
        alert("CPF do proprietário da propriedade inválido");
      }
    },

    getUnidadesMedidaVegetal() {

      axios
        .get(
          `/produtor/pre-cadastro/get-unidades-medida-vegetal`,
        )
        .then(response => response.data)
        .then(response => {
          const { data } = response;
          this.unidadesMedidaVegetal = data;
        })
        .catch(error => {
          console.log("error", error);
        })

    },
    getTiposProdutor() {
      axios
        .get(
          `/produtor/pre-cadastro/get-tipos-produtor`,
        )
        .then(response => response.data)
        .then(response => {
          const { data } = response;
          this.tiposProdutor = data;
        })
        .catch(error => {
          console.log("error", error);
        });
    },

    onChangeTipoProdutor() {
      this.exploracoes[this.activeIndex].nome_tipo_produtor = this.tiposProdutor.find(
        item => item.id === this.exploracoes[this.activeIndex].cod_tipo_produtor
      ).nome;
      this.ehArrendatario = this.exploracoes[this.activeIndex].cod_tipo_produtor == 2 ? true : false;
      this.exploracoes[this.activeIndex].cpf_proprietario_arrendamento = "";
      this.exploracoes[this.activeIndex].cod_propriedade_arrendamento = "";
    },

    onChangeUnidade() {
      this.exploracoes[this.activeIndex].nome_unidade = this.unidadesMedidaVegetal.find(
        item => item.cod === this.exploracoes[this.activeIndex].unidade
      ).nome;
    }
  },

  mounted() {
    this.exploracoes = this.explorationList;
    this.getCulturas();
    this.getTiposExploracao();
    this.getUnidadesMedidaVegetal();
    this.getTiposProdutor();
  }
};
</script>
<style lang="scss" scoped>
.cards {
  .card {
    .actions {
      width: 30px;

      i {
        cursor: pointer;
      }
    }
  }
}
.description {
  padding: 17px 0px;

  h4,
  h5 {
    margin: 0;
    overflow-wrap: break-word;
  }
}

/deep/ .sida-modal {
  max-width: 700px;
  .modal-content {
    height: 330px;
  }
}
</style>
